import { render, staticRenderFns } from "./addNewChat.vue?vue&type=template&id=47e0625f"
import script from "./addNewChat.vue?vue&type=script&lang=js"
export * from "./addNewChat.vue?vue&type=script&lang=js"
import style0 from "./addNewChat.vue?vue&type=style&index=0&id=47e0625f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports